import React from 'react';
import { Tooltip } from 'antd';
import * as Styled from 'components/Tables/DataEntry/DataEntry.styled';
import { SaveButtonProps } from './types';

const SaveButton: React.FC<SaveButtonProps> = ({
  token,
  hasChanges,
  onClick,
}) => (
  <Tooltip title={!hasChanges ? 'No changes to save' : ''}>
    <span>
      <Styled.AreaButton
        token={token}
        type="primary"
        onClick={onClick}
        disabled={!hasChanges}
      >
        Save
      </Styled.AreaButton>
    </span>
  </Tooltip>
);

export default SaveButton;
